import { NavLink, Outlet, useOutletContext } from 'react-router-dom';

const RADAR_TABS: { to: string; label: string; icon: string; end?: boolean }[] = [
  { to: '/painel/radar', label: 'Visão executiva', icon: 'ri-dashboard-3-line', end: true },
  { to: '/painel/radar/oportunidades', label: 'Oportunidades', icon: 'ri-radar-line' },
  { to: '/painel/radar/obras', label: 'Obras', icon: 'ri-building-4-line' },
  { to: '/painel/radar/empresas', label: 'Empresas', icon: 'ri-store-2-line' },
  { to: '/painel/radar/fontes', label: 'Fontes', icon: 'ri-rss-line' },
  { to: '/painel/radar/arquivadas', label: 'Arquivadas', icon: 'ri-archive-line' },
];

export default function RadarModule() {
  const { password } = useOutletContext<{ password: string }>();

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 flex items-center justify-center bg-[#E8610A]/10 text-[#E8610A] rounded-xl">
          <i className="ri-radar-line text-lg"></i>
        </div>
        <div>
          <h2 className="font-bold text-gray-900">Radar / Inteligência Comercial</h2>
          <p className="text-sm text-gray-500">
            Onde existe dinheiro se movendo e a HomeOffice Premium pode entrar — antes do CRM.
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 px-2 py-2 flex items-center gap-1 overflow-x-auto">
        {RADAR_TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors duration-150 cursor-pointer ${
                isActive ? 'bg-[#E8610A] text-white' : 'text-gray-600 hover:bg-gray-100'
              }`
            }
          >
            <i className={t.icon}></i>
            {t.label}
          </NavLink>
        ))}
      </div>

      <Outlet context={{ password }} />
    </div>
  );
}